import { Absolute, Color } from '@revolut-internal/ui-kit'
import { FC } from 'react'

const rightStyle = {
  transform: 'scaleX(-1)',
  right: '2px',
}
const leftStyle = {
  left: '2px',
}

interface ISubjectTailProps {
  color: Color
  position: 'left' | 'right'
}

export const SubjectTail: FC<ISubjectTailProps> = ({ color, position }) => {
  return (
    <Absolute
      bottom="-4px"
      style={position === 'left' ? leftStyle : rightStyle}
      data-testid="message-tail"
    >
      <svg
        width="19"
        height="20"
        viewBox="0 0 19 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 4.89027C19 12.8205 12.232 20 4.5 20H1.5H0.944342C0.171844 20 -0.250406 19.0993 0.243736 18.5055C1.12654 17.5335 1.87892 16.4348 2.47409 15.2368C3.601 12.9684 3.89567 10.1822 3.97272 5.64103L4 0L7.5 5.64103L19 4.89027Z"
          fill={color}
        />
      </svg>
    </Absolute>
  )
}
